import React, { memo } from 'react';
import {
  StyleSheet,
  TouchableOpacity,
  type TouchableOpacityProps,
} from 'react-native';
import { theme } from '@garnish/constants';

import { BodyText } from '../../../Text';

// ─────────────────────────────────────────────────────────────────────────────

export const IngredientListItemButton = memo((props: TouchableOpacityProps) => {
  const { children, style, ...restProps } = props;

  return (
    <TouchableOpacity
      accessibilityRole="button"
      style={[styles.pressable, style]}
      {...restProps}
    >
      <BodyText sizeMatch={['24']} style={styles.text}>
        {children}
      </BodyText>
    </TouchableOpacity>
  );
});

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  pressable: {
    minHeight: 48,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 60,
    paddingHorizontal: theme.spacing['4'],
    paddingVertical: theme.spacing['1'],
    gap: theme.spacing['2'],
    backgroundColor: theme.colors.OPACITY.DARK_KALE.ALMOST_TRANSPARENT,
  },
  text: {
    textAlign: 'center',
    color: theme.colors.BLACK,
  },
});
